var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCare1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 143.3 155.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #ffac8f;\r\n      }\r\n\r\n      .st1 {\r\n        mix-blend-mode: multiply;\r\n        opacity: .6;\r\n      }\r\n\r\n      .st2 {\r\n        fill: #e28079;\r\n      }\r\n\r\n      .st3 {\r\n        fill: #bab2bf;\r\n      }\r\n\r\n      .st4 {\r\n        fill: #ffa143;\r\n      }\r\n\r\n      .st5 {\r\n        fill: #cc7b62;\r\n      }\r\n\r\n      .st6 {\r\n        fill: #56548c;\r\n      }\r\n\r\n      .st7 {\r\n        fill: #ddd7e0;\r\n      }\r\n\r\n      .st8 {\r\n        fill: #444472;\r\n      }\r\n\r\n      .st9 {\r\n        isolation: isolate;\r\n      }\r\n\r\n      .st10 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .st11 {\r\n        fill: #6a8f7e;\r\n      }\r\n\r\n      .st12 {\r\n        fill: #ad4b44;\r\n      }\r\n\r\n      .st13 {\r\n        fill: #bc574a;\r\n      }\r\n\r\n      .st14 {\r\n        fill: #858496;\r\n      }\r\n\r\n      .st15 {\r\n        fill: #98b7a9;\r\n      }\r\n\r\n      .st16 {\r\n        fill: #c7becc;\r\n      }\r\n\r\n      .st17 {\r\n        fill: #f9ad62;\r\n      }\r\n\r\n      .st18 {\r\n        fill: #d3cbd8;\r\n      }\r\n\r\n      .st19 {\r\n        fill: #878cf0;\r\n      }\r\n\r\n      .st20 {\r\n        fill: #bdbdc6;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\uB808\\uC774\\uC5B4_1",
    "data-name": "\\uB808\\uC774\\uC5B4_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.2,38.8s6.8,1.3,8.4,2.2c1.6.9,4.2,5,3.1,5.8-.7.5-2.3-.6-2.3-.6,0,0-2.6,4.5-6.3,3-3.9-1.6-4-1.8-4-1.8,0,0,1.1-8.6,1.1-8.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.7,31.4s-3.9,10.2,5.6,12.7c9.5,2.5,21.6,2.7,21.6,2.7l1.4-7-16.2-7-12.5-1.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M36.5,20.9c.3-.6,1.7-.9,2.3-.5,3.1,2.5,8.5,9.8,12.1,12.1,4.6,2.9,12.5,6,12.5,6l-2.8,8.2s-13.9,4.9-21.9-4.3c-6.5-7.5-4-18.1-2.2-21.5h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st7",
    cx: 71.1,
    cy: 150.8,
    rx: 71.1,
    ry: 4.7
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "32.3 116.2 34.1 137.6 46.9 137 46.9 114.7 32.3 116.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "17.3 116.2 18.4 136.5 31 136 32.3 113.4 17.3 116.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5,4.7s-2.1,4-2.1,13.4v9.4l18,.4s-.4-20.9-2.3-24.4-13.6,1.2-13.6,1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M44.4,52.6s4.5,18.2,6.3,33.5c1.9,15.4,1.4,41.2.2,42.1-1.3.9-14.6,1.3-14.6,1.3,0,0-5,2.1-13.6,1.9-6.2-.2-8.7-1.9-8.7-1.9,0,0-1.1-66.8,3.6-77.3,3.7-8.3,26.8.3,26.8.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45,50.2v3.8s-9.4,2.2-17.1,1.6c-7.7-.6-10.6-2-10.6-2l-3.3-19.2,10.3-14.2,7.6-.6h2.5c1.1.1,2.2.3,3.3.5l1,.2,6,27.3.3,2.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.3,8.7s3.7-1.6,4,1.3c.3,3.4-3.7,3.4-3.7,3.4l-.3-4.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M35.2,11.8s0,0-.1,0c-.1,0-.2-.2,0-.3l1.2-2.1c0-.1.2-.2.3,0s.2.2,0,.3l-1.2,2.1c0,0-.1.1-.2.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M36.7,11.1h-1.1c-.1,0-.2-.1-.2-.3s.1-.2.2-.2h1.1c.1,0,.2.1.2.3s-.1.2-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.6,16v5s1.5.8,3.4.9c2.6,0,3.4-1.5,3.4-1.5v-4.6s-6.8.2-6.8.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M26.6,16.6s1.2,3.6,4.1,3.1c2.3-.4,2.9-3.8,2.9-3.8l-7,.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.5,5.8s1.6,7.2-.4,10.4c-2.2,3.4-5.5,2.2-6.8,1.2-1.8-1.4-2.4-3.1-2.4-3.1,0,0-2.5.5-3.3-1.5-.9-2.1.7-3.8,1.9-3.9s1.4.1,1.4.1l-.4-2.3s7.5-8.3,10-.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M24.5,12.2c0,0-.1,0-.2,0l-1.9-1.6c-.1,0-.1-.2,0-.4s.2-.1.4,0l1.9,1.6c.1,0,.1.2,0,.4,0,0-.1,0-.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M22.7,12.5c0,0-.1,0-.2-.1,0-.1,0-.3,0-.4l1.1-.8c.1,0,.3,0,.4,0,0,.1,0,.3,0,.4l-1.1.8s-.1,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M30.9,13.5s-.1,0-.1,0c-.1,0-.1-.2,0-.4.7-1.1,0-2.8,0-2.8,0-.1,0-.3.1-.3.1,0,.3,0,.3.1,0,0,.8,1.9,0,3.3,0,0-.1.1-.2.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5,8c0,0-.1,0-.2,0-.3-.3-.9-.4-1.1-.4-.1,0-.2-.1-.2-.3s.1-.2.3-.2.9,0,1.4.6c0,0,0,.3,0,.3,0,0-.1,0-.2,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5,8s0,0-.1,0c0,0,0-.2,0-.3.5-.5,1.3-.6,1.3-.6.1,0,.2,0,.2.2,0,.1,0,.2-.2.2,0,0-.7,0-1.1.5,0,0-.1,0-.1,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M30.6,15.6c0,0-.2,0-.3,0-.4-.1-.7-.5-.9-1,0,0,0-.2,0-.2,0,0,.2,0,.2,0l1.8.5c0,0,.1.1.2.2,0,0,0,.2,0,.2,0,0-.5.4-1,.4h0ZM30.2,14.9c0,.1.2.2.3.2.1,0,.3,0,.4,0,0,0-.7-.2-.7-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,8.4s-1.1-1.7-1.9-2.9l-.9-1.2s-.8,2.8-2.7,4c-1.9,1.2-4.2,1-4.2,1v1.7c0,0-.6-2.3-.9-2.3-.4,0-.9-.1-1.6.2-.6.3-.8.6-.8.6,0,0-.8-4.1-.4-5S24.7-1.7,31.9.5c5.4,1.7,3.1,7.9,3.1,7.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8,10.5c-.1,0-.2-.1-.2-.2v-1.2c0,0,0-.1,0-.2l.6-.5c0,0,.3,0,.3,0s0,.3,0,.4l-.5.5v1.1c0,.1,0,.3-.2.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8,10.7c-.1,0-.2-.1-.2-.2v-1.2c0,0,0-.1,0-.2l.6-.6c0-.1.2-.1.4,0,.1,0,.1.2,0,.4l-.5.6v1.1c0,.1,0,.3-.2.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M67.1,150.9c.3,0,.5-.3.5-.6-.2-1.5-1.1-5.8-3.4-7.6-2.9-2.3-9-3.2-11.2-4.8s-4.7-5.1-6-4.4c-1.3.6-3.9,3.7-7.5,3.2s-5.3-1.4-6.3-.6c-1,.9-1.8,13.2-1.4,13.9s5.5.2,6,.3c.4.1,1.8-2.8,2.6-2.3s1.8,1.9,3,2.5c1.1.6,20.1.9,23.8.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M34.2,148.5c0,1.3-.4,2.8-1.3,3.1s-8,1.1-14.3.6c-6-.5-5.9-.3-6.4-.9-.2-.3-1.1-2.2-.6-3.5,0,0,0-.1,0-.2.2-.6.5-1.2.7-1.7.2-.4.4-.8.7-1.2.6-.9,1.9-2.7,2.3-3.7.4-1.3,1.1-4,1.5-5.3.3-1,4.3-2.5,6.1-3.2.7-.2,1.4-.3,2-.2,1.9.4,5.9,1.1,6.5,1.7.9.7,1.3,6.8,1.3,7.7v.9c0,.9.6,2.5,1,3.9,0,.4.2.7.2,1,0,.3,0,.6,0,.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M35.2,125.7c-.1,0-.2-.1-.2-.2l-1.9-58.9c0,0,0-.2.1-.2l5.6-2.9c.1,0,.3,0,.3.1,0,.1,0,.3-.1.3l-5.5,2.8,1.9,58.7c0,.1,0,.2-.2.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M48.9,140.4c0,0-.2,0-.2-.1,0-.1,0-.3,0-.3l4-2.3c.1,0,.3,0,.3,0s0,.3,0,.3l-4,2.3s0,0-.1,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M52.9,141.3c0,0-.2,0-.2-.1,0-.1,0-.3,0-.3l3.1-1.8c.1,0,.3,0,.3,0s0,.3,0,.3l-3.1,1.8s0,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M27.3,140.4s0,0-.1,0c-2.2-1-6.7,0-6.8,0-.1,0-.3,0-.3-.2,0-.1,0-.3.2-.3.2,0,4.7-1.1,7.1,0,.1,0,.2.2.1.3,0,0-.1.1-.2.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M27.3,143s0,0-.1,0c-2.2-1-6.7,0-6.8,0-.1,0-.3,0-.3-.2,0-.1,0-.3.2-.3.2,0,4.7-1.1,7.1,0,.1,0,.2.2.1.3,0,0-.1.1-.2.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M81.6,32.5s-5.8.3-6.5-5.2,1-6.8,1-6.8h5.2s.3,12.1.3,12.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M99.5,81c-.6,0-1-.5-1-1v-20.3c0-.6.5-1,1-1s1,.5,1,1v20.3c0,.6-.5,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M119.8,80.9c-.5,0-1-.4-1-1,0,0-.3-4.2-2.3-6.8-2.4-3-12.7-6-16.5-7-.6-.1-.9-.7-.8-1.2.1-.6.7-.9,1.2-.8,1.5.4,14.3,3.6,17.6,7.7,2.4,3,2.8,7.7,2.8,7.9,0,.6-.4,1.1-1,1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M57,44.5h44.3c.9,0,1.7.8,1.7,1.7v15.4c0,.9-.8,1.7-1.7,1.7h-44.3c-.9,0-1.7-.8-1.7-1.7v-15.4c0-.9.8-1.7,1.7-1.7Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M120.4,150.8c-12.6,0-22.9-16.1-22.9-36s10.3-36,22.9-36,22.9,16.1,22.9,36-10.3,36-22.9,36ZM120.4,80.9c-11.5,0-20.8,15.2-20.8,33.9s9.3,33.9,20.8,33.9,20.8-15.2,20.8-33.9-9.4-33.9-20.8-33.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M119.4,114.2c-.1,0-.2,0-.3-.2l-6.3-32.1c0-.2,0-.3.2-.3.2,0,.3,0,.3.2l6.1,31,9.2-30.3c0-.1.2-.2.3-.2s.2.2.2.3l-9.5,31.4c0,.1-.1.2-.3.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M113.1,148.1h0c-.2,0-.2-.2-.2-.3l6.3-32.1c0-.1.1-.2.2-.2.2,0,.2,0,.3.2l9.5,31.4c0,.1,0,.3-.2.3-.1,0-.3,0-.3-.2l-9.2-30.3-6.1,31c0,.1-.1.2-.3.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M99.6,125.7c0,0-.2,0-.2-.1,0-.1,0-.3,0-.4l18.7-10.4-18.2-12.8c-.1,0-.2-.2,0-.4,0-.1.2-.2.4,0l18.5,13c0,0,.1.1.1.2,0,0,0,.2-.1.2l-19,10.6s0,0-.1,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M140.2,125.7s0,0-.1,0l-19.1-10.6c0,0-.1-.1-.1-.2,0,0,0-.2.1-.2l18.5-13c.1,0,.3,0,.4,0,0,.1,0,.3,0,.4l-18.2,12.8,18.7,10.4c.1,0,.2.2.1.4,0,0-.1.1-.2.1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st16",
    cx: 119.4,
    cy: 113.9,
    rx: 4.2,
    ry: 9.3
  })), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M82,149.5c-.5,0-.9-.4-1-.9l-8.4-54.4c0-.6.3-1.1.8-1.2.6,0,1.1.3,1.2.8l8.4,54.4c0,.6-.3,1.1-.8,1.1,0,0,0,0-.2,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M126.8,149.8c-.5,0-.9-.4-1-.9l-8.4-54.4c0-.6.3-1.1.8-1.2.6,0,1.1.3,1.2.8l8.4,54.4c0,.6-.3,1.1-.8,1.1,0,0,0,0-.2,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M58.8,81c-.6,0-1-.5-1-1v-20.3c0-.6.5-1,1-1s1,.5,1,1v20.3c0,.6-.5,1-1,1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st18",
    x: 79.4,
    y: 144.7,
    width: 54.8,
    height: 7.5,
    rx: 2.6,
    ry: 2.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M58.8,81.5l13.9,12.2c.3.2.6.4,1,.4h29.8c1.4.1,2-1.6,1-2.5l-14.9-12.3c-.3-.2-.6-.3-.9-.3h-28.9c-1.4,0-2,1.7-1,2.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "96.3 123.7 96.3 135.5 87.3 138.9 81.6 132.5 80.7 121.6 96.3 123.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "113.1 121.2 113.1 133 103.5 136.4 97.5 130.1 96.5 119.1 113.1 121.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M93.5,66.5s22.9,11.5,25.7,16.2c2.8,4.7-.3,42.8-.3,42.8l-20.3.3-2.8-21.3-15.4-35.9s13.1-2.1,13.1-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M67.3,67.1s-.4,11.8-.1,15.2,8,8.8,8,8.8l1.4,35.6,23.5,1.1s.5-37.4.1-40.9c-.4-3.5-16-16.3-16-16.3,0,0-16.8-3.3-16.9-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M101.1,124.9c-.1,0-.2-.1-.2-.3,0-.3.9-34.9,0-39-.6-2.8-8.1-10.1-8.2-10.2,0,0,0-.2,0-.2,0,0,0-.2.2-.2l5.8-2c.1,0,.3,0,.3.2,0,.1,0,.3-.2.3l-5.4,1.8c1.4,1.4,7.5,7.6,8.1,10.2.9,4.1,0,37.7,0,39.1,0,.1-.1.2-.2.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M75.7,91.3s0,0-.1,0c0,0-.1-.1-.1-.2,0-.1.3-3.4,1.9-4.4.5-.4,1.2-.4,1.8-.2.6.2.9.5.9.9.2,1.4-3.6,3.6-4.3,4,0,0,0,0-.1,0h0ZM78.5,86.8c-.3,0-.6,0-.8.3-1.1.7-1.5,2.7-1.7,3.6,1.6-1,3.7-2.5,3.6-3.3,0-.2-.2-.3-.6-.5-.2,0-.4,0-.6,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M79.3,97.7c-.6,0-1-.4-1-1,0-5-.8-18.7-3.2-21.6-2.4-2.9-12.7-6-16.5-7-.5-.1-.9-.7-.8-1.3.1-.6.7-.9,1.3-.8,1.5.4,14.2,3.7,17.5,7.7,3.3,4,3.7,21,3.7,22.9,0,.6-.4,1-1,1.1h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M60.5,150.8c-12.6,0-22.9-16.1-22.9-36s10.3-36,22.9-36,22.9,16.1,22.9,36-10.3,36-22.9,36ZM60.5,80.9c-11.5,0-20.9,15.2-20.9,33.9s9.3,33.9,20.8,33.9,20.8-15.2,20.8-33.9-9.3-33.9-20.8-33.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M59.5,114.2c-.1,0-.2,0-.3-.2l-6.3-32.1c0-.2,0-.3.2-.3.2,0,.3,0,.3.2l6.1,31,9.2-30.3c0-.1.2-.2.3-.2s.2.2.2.3l-9.5,31.4c0,.1-.1.2-.3.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M53.2,148.1h0c-.2,0-.2-.2-.2-.3l6.3-32.1c0-.1.1-.2.2-.2.2,0,.2,0,.3.2l9.5,31.4c0,.1,0,.3-.2.3-.1,0-.3,0-.3-.2l-9.2-30.3-6.1,31c0,.1-.1.2-.3.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M39.7,125.7c0,0-.2,0-.2-.1,0-.1,0-.3,0-.4l18.7-10.4-18.2-12.8c-.1,0-.2-.2,0-.4,0-.1.2-.2.4,0l18.5,13c0,0,.1.1.1.2,0,0,0,.2-.1.2l-19,10.6s0,0-.1,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M80.4,125.7s0,0-.1,0l-19-10.6c0,0-.1-.1-.1-.2,0,0,0-.2.1-.2l18.5-13c.1,0,.3,0,.4,0,0,.1,0,.3,0,.4l-18.2,12.8,18.7,10.4c.1,0,.2.2,0,.4,0,0-.1.1-.2.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M63.8,113.9c0,5.2-1.9,9.3-4.2,9.3s-4.2-4.2-4.2-9.3,1.9-9.3,4.2-9.3,4.2,4.2,4.2,9.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M97.5,68.6s1.5-26.8-6.4-30.7c-8.7-4.2-18.9-.3-18.9-.3l.3,33.1,25.1-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M114.7,127.1s5,5.9,6.2,6.5c1.2.6,13.4,4.7,15.7,6.9,2.3,2.3,2.5,6.8,1.8,7.2s-40.7,0-40.7,0l-.4-19.3,17.4-1.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M118.8,131.2s-5.6,6.4-4.3,6.9c1.3.5,12.1-1.1,11.8-2.3-.3-1.1-6.2-4.7-7.5-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.2,64.2s.3,0,1.6.2c1.2.2,4.9,2.4,4.9,2.4,0,0,3,2.2,5.2,4.7,2.2,2.5,1.2,3.6,1.2,3.6,0,0,1.3,1.8.2,2.3s-3.6-1.5-3.6-1.5c0,0,3.1,2.9,1.2,3.1s-5.6-3.7-5.6-3.7c0,0-8.4-.4-9.7-3.9-1.3-3.5,4.7-7.2,4.7-7.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M85.6,61.9l-4.7,11.9s-16.8,1.4-21.3-8.1c-5.1-10.9,5.6-26.2,12.2-28,6.6-1.8,4.7,17.5,4.7,17.5l9.2,6.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1,75.3c0,0-.1,0-.2,0,0,0-1.7-2.6-4.2-5,0,0,0-.2,0-.3s.2,0,.3,0c2.6,2.4,4.2,5,4.2,5,0,0,0,.2,0,.3,0,0,0,0-.1,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1,76.2c0,0-.1,0-.2,0,0,0-1.3-2.3-3-3.4,0,0-.1-.2,0-.3,0,0,.2-.1.3,0,1.8,1.1,3.1,3.4,3.1,3.5,0,0,0,.2,0,.3,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.3,62.4s-.3,0-1.6.3c-1.2.3-4.7,2.8-4.7,2.8,0,0-2.9,2.4-4.9,5.1s-.9,3.6-.9,3.6c0,0-1.1,1.9,0,2.3s3.5-1.8,3.5-1.8c0,0-2.8,3.1-1,3.2s5.3-4.1,5.3-4.1c0,0,8.3-1,9.4-4.6,1.1-3.6-5.2-6.9-5.2-6.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M90.2,74.5s0,0-.1,0c-.1,0-.2-.2,0-.3,0,0,1.5-2.7,3.9-5.3,0,0,.2-.1.3,0,0,0,.1.2,0,.3-2.3,2.6-3.8,5.2-3.8,5.2,0,0-.1.1-.2.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M93.3,75.1s0,0,0,0c-.1,0-.2-.2-.1-.3,0,0,1.2-2.5,2.8-3.8.1,0,.3,0,.3,0s0,.3,0,.3c-1.6,1.2-2.7,3.6-2.7,3.6,0,0-.1.2-.2.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M104.9,139.4s-6.4-7.6-8.4-9.8l-15.1.6c-1.4,3.1-1.5,12.4-.5,14.9,1,2.4,8.7,6.5,18.7,6.4,4.7,0,11.6-1.5,11.6-3.1,0-2.6-4.6-7.4-6.2-9.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M102.9,137.8s-4.3-5.1-8.3-4-5.1,3.9-4.2,4.7,11.6.9,12.5-.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M84.3,61.2c0,0-.1,0-.2,0,0,0-6.2-5.2-10.9-7-.1,0-.2-.2-.1-.3,0-.1.2-.2.3-.1,4.8,1.9,11,7.1,11,7.1.1,0,.1.2,0,.3,0,0-.1,0-.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M75.3,55c0,0-.1,0-.2,0-.7-.6-2.9-2.7-2.8-3.6,0-.2.2-.3.3-.4.3-.1.6-.1.9,0,1.2.6,1.9,3.4,2,3.8,0,.1,0,.2-.1.3,0,0,0,0-.1,0h0ZM73.1,51.3c0,0-.1,0-.2,0,0,.4.8,1.5,1.9,2.6-.3-1-.9-2.3-1.5-2.6,0,0-.2,0-.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.7,24.5s3.8-1.6,4,1.3c.3,3.4-3.7,3.4-3.7,3.4l-.3-4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M88.5,27.6s0,0-.1,0c-.1,0-.2-.2,0-.3l1.3-2.1c0-.1.2-.2.3,0,.1,0,.2.2,0,.3l-1.3,2.1c0,0-.1.1-.2.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M90,27h-1.1c-.1,0-.2-.2-.2-.3,0-.1.1-.2.2-.2h1.1c.1,0,.2.2.2.3,0,.1-.1.2-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.8,31.7v5s1.9,1.1,3.8,1.2c2.6,0,3-.6,3-.6v-5.8l-6.8.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M79.9,32.4s1.2,3.6,4.1,3.2c2.3-.3,2.9-3.8,2.9-3.8l-7,.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.9,21.7s1.6,7.2-.5,10.4c-2.2,3.4-5.5,2.2-6.8,1.2-1.8-1.4-2.4-3.2-2.4-3.2,0,0-2.5.5-3.3-1.5-.8-2.1.7-3.8,1.9-3.9s1.4.1,1.4.1l-.3-2.3s7.6-8.3,10.1-.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M77.8,28c0,0-.1,0-.2,0l-1.9-1.6c0,0-.1-.2,0-.4,0-.1.2-.1.3,0l1.9,1.6c0,0,.1.2,0,.4,0,0-.1,0-.2,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M76,28.3c0,0-.2,0-.2-.1,0-.1,0-.3,0-.4l1.1-.8c.1,0,.3,0,.3,0,0,.1,0,.3,0,.4l-1.1.8s0,0-.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M84.2,29.3s0,0-.1,0c-.1,0-.1-.2,0-.4.7-1.1,0-2.8,0-2.8,0-.1,0-.3.1-.3.1,0,.3,0,.3.1,0,0,.8,2-.1,3.3,0,0-.1.1-.2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M87.3,23.6c0,0-.1,0-.2,0-.3-.3-.9-.4-1.1-.4-.1,0-.2-.1-.2-.3,0-.1,0-.2.3-.2,0,0,.9,0,1.4.6,0,.1,0,.3,0,.4,0,0-.1,0-.2,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8,23.8s0,0-.1,0c0,0,0-.2,0-.3.5-.5,1.3-.6,1.3-.6.1,0,.2,0,.2.2s0,.2-.2.2c0,0-.7,0-1.1.5,0,0,0,0-.2,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M88.3,24.3s-1.1-1.7-1.9-2.9l-.9-1.2s-.8,2.8-2.8,4-4.2,1-4.2,1v1.7c0,0-.5-2.3-.9-2.3-.4,0-.9-.1-1.6.2-.7.3-.8.6-.8.6,0,0-.8-4.1-.4-5,.4-.9,3.2-6.4,10.4-4.1,5.4,1.7,3,7.9,3,7.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1,26.3c-.1,0-.2-.1-.2-.2v-1.2c0,0,0-.1,0-.2l.6-.5c0,0,.3,0,.3,0,0,.1,0,.3,0,.4l-.5.5v1.1c0,.1,0,.2-.2.3h0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1,26.5c-.1,0-.2-.1-.2-.2v-1.2c0,0,0-.1,0-.2l.6-.6c0-.1.2-.1.3,0s.1.2,0,.4l-.5.5v1.1c0,.1,0,.2-.2.3h0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M78.1,18.9s-1.3-6.2-4.7-5.1c-4.7,1.6-.6,9.1,2.3,9.1s2.4-4,2.4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M86.8,36.7s-3.8,1.9-7-.4c0,0-2.1,4.2-.3,4.7,1.7.5,4.9-3.2,4.9-3.2,0,0,2.5,2.5,3.6,2.4s-1.2-3.6-1.2-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.5,43s-2.2-2.5-3.1-2.8-7.4.4-7.4.4l8.1,2.7s2.3-.3,2.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.3,20.1l.8,7.2s-3.8-1.9-5.4-3.6c-1.9-2-2.1-3.4-2.1-3.4,0,0,3.2,1.1,6.8-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M37.9,29.4s0,0,0,0c-.4-.2-9.6-4.2-11.4-9.1,0-.1,0-.3.1-.3.1,0,.3,0,.3.1,1.8,4.7,11.1,8.8,11.1,8.8.1,0,.2.2.1.3,0,0-.1.1-.2.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M34.2,27.5c-.1,0-.2-.1-.2-.2l-.8-7.6c0-.1,0-.3.2-.3.1,0,.3,0,.3.2l.8,7.6c0,.1,0,.3-.2.3h0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M92,38.5s11.5,6.7,15.2,17.2c3.7,10.5-1.2,16.9-1.2,16.9l-8.9-8.4s-5.1-25.6-5.1-25.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M94,61.2c-.1,0-.2-.1-.2-.2v-3.7c0,0,0,0,0-.1,0,0,1.6-2.7,2-6.1.3-2.7-2-8-2-8.1,0-.1,0-.3.1-.3.1,0,.3,0,.3.1,0,.2,2.3,5.5,2,8.3-.4,3.2-1.8,5.8-2,6.2v3.6c0,.1,0,.2-.2.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M97.6,61.2s0,0,0,0c-.1,0-.2-.2-.2-.3,0-.2,1.4-3.8,4-4.9.1,0,.3,0,.3.1,0,.1,0,.3-.1.3-2.4,1.1-3.7,4.6-3.7,4.6,0,0-.1.2-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M98.8,58.8h0c-.1,0-.2-.1-.2-.2,0-.1-.2-2.7.7-3.7.3-.3.6-.4,1-.4s.3,0,.4.2c.4.7-1,3-1.6,4,0,0-.1.1-.2.1h0ZM100.2,55c-.2,0-.4.1-.6.3-.5.5-.6,1.6-.6,2.4.8-1.3,1.3-2.5,1.2-2.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M56.7,47.3c0,0-.2,0-.2,0l-5.9-1.5c-.5-.1-.9-.7-.8-1.2.1-.5.7-.9,1.2-.8l5.9,1.5c.5.1.9.7.8,1.2-.1.5-.5.8-1,.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M50.6,46.3h-8.5c-.9,0-1.7-.8-1.7-1.7s.8-1.7,1.7-1.7h8.5c.9,0,1.7.8,1.7,1.7s-.8,1.7-1.7,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.4,40.2s8.2.7,10,1.8c1.8,1.1,5,5.9,3.7,6.9-.8.6-2.7-.8-2.7-.8,0,0-3.1,5.3-7.4,3.6-4.6-1.9-4.7-2.1-4.7-2.1,0,0,1.2-9.4,1.2-9.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M46.3,48.4s0,0-.1,0l-.9-.5c-.1,0-.2-.2,0-.3,0-.1.2-.2.3,0l.9.5c.1,0,.2.2,0,.3,0,0-.1.1-.2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M46.5,43.5c0,0-.1,0-.2,0l-1.8-1.7c0,0-.1-.2,0-.3s.2-.1.3,0l1.8,1.7c0,0,.1.2,0,.3,0,0-.1,0-.2,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.3,20.3S7.9,26.4,7.9,41.2c0,10,7.7,13.5,15.9,14.1,7.2.5,12.8-1.3,12.8-1.3l-1.2-15.4-11.1-18.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M32.2,39.5h0c0,0-7-1.8-11.8-1.7-.1,0-.2-.1-.2-.2s.1-.2.2-.2c4.9,0,11.9,1.7,12,1.7.1,0,.2.2.2.3,0,.1-.1.2-.2.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M22.9,37.9s0,0-.1,0c-.4-.2-3.6-1.9-3.7-3.2,0-.3,0-.5.3-.7.2-.2.5-.2.7-.2,1.3.2,2.9,3.3,3.1,3.7,0,0,0,.2,0,.3,0,0-.1,0-.2,0h0ZM19.8,34.4c0,0-.1,0-.2,0,0,0-.1.1-.1.2,0,.6,1.5,1.6,2.7,2.3-.7-1.2-1.7-2.5-2.3-2.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M63.3,44.7s0,0,0,0c-.8-.3-1.4-2-1.5-2.2,0-.1,0-.2.1-.3.1,0,.2,0,.2.1.2.5.7,1.7,1.2,2,0,0,.2.2.1.3,0,0-.1.1-.2.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M49.4,35.9c0,0-.1,0-.2,0-.2,0-.4-.2-.5-.4-.4-1,.8-3.5.9-3.7,0-.1.2-.1.3-.1.1,0,.2.1.2.2,0,.5.5,3.3-.3,4-.1,0-.3.2-.4.2h0ZM49.7,32.7c-.4.9-.8,2.1-.5,2.5,0,0,0,.1.2.2,0,0,.1,0,.2,0,.3-.3.3-1.5.2-2.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M83.9,31.4c-.9,0-1.5-.9-1.5-.9,0-.1,0-.3,0-.4s.3,0,.3,0c0,0,.6.9,1.3.7.1,0,.3,0,.3.2,0,.1,0,.3-.2.3-.1,0-.2,0-.3,0h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCare1);
export default __webpack_public_path__ + "static/media/care1.d2270625e803e38cd659b3f90291b12c.svg";
export { ForwardRef as ReactComponent };